import { MessageCircle } from 'lucide-react';
import type { TopicSuggestion } from '../shared/types.ts';

export function TopicCard({ topic }: { topic: TopicSuggestion }) {
  return (
    <div className="bg-card rounded-2xl border border-border shadow-sm overflow-hidden">
      <div className="w-full aspect-[16/7] bg-gradient-to-br from-primary/15 via-primary/5 to-transparent flex items-center justify-center">
        <MessageCircle size={48} className="text-primary/60" />
      </div>

      <div className="p-6 space-y-4">
        <div>
          <span className="inline-block text-[10px] uppercase tracking-wider font-semibold text-primary/80 bg-primary/10 rounded-full px-2 py-0.5">
            {topic.label}
          </span>
          <p className="font-bold text-xl leading-snug mt-2">{topic.question}</p>
        </div>

        {topic.description && (
          <p className="text-[15px] text-foreground/85 leading-relaxed">{topic.description}</p>
        )}
      </div>
    </div>
  );
}
